// extracted by mini-css-extract-plugin
export default {"phraseWrapper":"Ellipsis_phraseWrapper__iCjC7"};